import styled from 'styled-components';
import { FlexCenterBoth } from 'components/primitives/flex';
import { mediaMMdMax } from 'helpers/breakpoints';
import { ReactNode } from 'react';
import BookingActionButton, { BookingActionButtonProps } from './BookingActionButton';
import { ButtonVariant } from './types';
import CloseIcon from '../../icons/CloseIcon';

interface Props {
  title: ReactNode;
  ctaText: string;
  userType: ButtonVariant;
  subText?: string;
  subtitle?: string;
  showSubtitle?: boolean;
  ctas?: BookingActionButtonProps[];
  subHeading?: ReactNode;
  showCloseButton: boolean;
  onClose?: () => void;
  onSubmit: () => void;
}

const BookingActionsBox = ({
  title = 'What would you like to do?',
  subtitle = 'This is only visible to you.',
  showSubtitle = true,
  showCloseButton = false,
  ctaText,
  userType,
  subText,
  ctas,
  subHeading,
  onSubmit,
  onClose,
}: Props) => (
  <BookingActionsBoxWrapper>
    {showCloseButton && (
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    )}

    <BookingActionsTitle>{title}</BookingActionsTitle>
    <SubHeading>{subHeading}</SubHeading>

    <BookingActionButton ctaText={ctaText} userType={userType} onSubmit={onSubmit} subText={subText} />
    {ctas &&
      ctas.map((cta, index) => (
        <ButtonWrapper key={index} className={`${cta.justText ? 'justTextWrapper' : ''}`}>
          <BookingActionButton {...cta} />
        </ButtonWrapper>
      ))}
    {showSubtitle && <BookingActionsTag>{subtitle}</BookingActionsTag>}
  </BookingActionsBoxWrapper>
);

export default BookingActionsBox;

const BookingActionsBoxWrapper = styled(FlexCenterBoth)`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-left: 40px;
  margin-right: 40px;
  margin-bottom: 40px;
  padding: 30px 40px;
  max-width: calc(100% - 80px);
  width: 100%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #dbdfe5;
  border-radius: 16px;
  position: relative;
  ${mediaMMdMax} {
    margin-left: 0px;
    margin-right: 0px;
    max-width: 100%;
  }
`;

const CloseButton = styled.button`
  background: #f5f7f9;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  position: absolute;
  right: 15px;
  top: 15px;
  svg {
    margin: auto;
  }
`;

const BookingActionsTitle = styled.h3`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: black;
  text-align: center;
`;

const SubHeading = styled.p`
  font-size: 16px;
  line-height: 130%;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  margin-top: 25px;
  width: 100%;
  &.justTextWrapper {
    padding-top: 10px !important;
  }
`;

const BookingActionsTag = styled.span`
  text-align: center;
  color: #767676;
  font-size: 12px;
  line-height: 16px;
  margin: 20px 0 0px 0;
  font-weight: 400;
`;
